import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Gracias } from './pages/Gracias';
import { Seguimiento } from './pages/Seguimiento';
import { initTracking } from './utils/analytics';
export function App() {
  useEffect(() => {
    initTracking();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3fb9h94vv92kg">
      <Routes data-id="element-1" data-mp="3f8n9p58z6n28">
        <Route path="/" element={<Landing data-id="element-3" data-mp="2rlyr0hc56qkk" />} data-id="element-2" data-mp="2rknlod31tarc" />
        <Route path="/gracias" element={<Gracias data-id="element-5" data-mp="2riklx1c3g39f" />} data-id="element-4" data-mp="2rlf6csv3xo2u" />
        <Route path="/seguimiento" element={<Seguimiento data-id="element-7" data-mp="2mn59mdtqiff4" />} data-id="element-6" data-mp="2mmceka451ect" />
        <Route path="*" element={<Landing data-id="element-9" data-mp="31agmqk5ke7hc" />} data-id="element-8" data-mp="2mjpwvhnj9igv" />
      </Routes>
    </BrowserRouter>;
}